import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";

type WidthProps = {
  delay?: number;
  duration?: number;
  distance?: number;
  width: string;
  widthMobile: string;
};

const Width: React.FC<WidthProps> = (props) => {
  const controls = useAnimation();
  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);

  const getValue = () => {
    if (typeof window !== `undefined`) {
      return window.innerWidth < 767 ? props.widthMobile : props.width;
    }
  };

  const list = {
    visible: { width: getValue() },
    hidden: { width: 0 },
  };

  return (
    <motion.div
      className="animation-width"
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={list}
      transition={{
        delay: props.delay || 0,
        duration: props.duration || 0.6,
        ease: "easeIn",
      }}
    >
      {props.children}
    </motion.div>
  );
};

export default Width;
